import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86f248f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "measurement-layout" }
const _hoisted_2 = { class: "measurement-layout-menu" }
const _hoisted_3 = { class: "measurement-layout-content" }

import AuthorizedLayout from '@/layouts/AuthorizedLayout.vue';
import { NTabs, NTabPane } from 'naive-ui';
import { computed, onBeforeMount, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

enum Tabs {
	CreateNewMeasurement = 'nove-mereni',
	MeasurementDetail = 'detail',
	MeasurementList = 'prehled',
}
enum RouteName {
	CreateNewMeasurement = 'NewMeasurementPage',
	MeasurementDetail = 'DetailMeasurementPage',
	MeasurementList = 'MeasurementsListPage',
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const { dispatch } = useStore();
const { push } = useRouter();
const currentTab = ref<string>('uzivatele');
const tabs = computed<Array<{ id: Tabs; label: string; show: boolean }>>(() =>
	[
		{ id: Tabs.MeasurementList, label: 'Přehled měření', show: true },
		{
			id: Tabs.MeasurementDetail,
			label: 'Detail měření',
			show: route.name === RouteName.MeasurementDetail,
		},
		{
			id: Tabs.CreateNewMeasurement,
			label: 'Nový měření',
			show: route.name === RouteName.CreateNewMeasurement,
		},
	].filter((item) => item.show),
);

const setTab = (routeName: RouteName): void => {
	let value: string;

	switch (routeName) {
		case 'NewMeasurementPage':
			value = Tabs.CreateNewMeasurement;
			break;
		case 'DetailMeasurementPage':
			value = Tabs.MeasurementDetail;
			break;
		case 'MeasurementsListPage':
		default:
			value = Tabs.MeasurementList;
			break;
	}
	currentTab.value = value;
};
const fetchLists = async () => {
	await dispatch('lists/fetchData');
};
const changeTab = (value: string) => {
	push(`/mereni/${value}`);
};
onBeforeMount(async () => {
	fetchLists();
	setTab(route.name as RouteName);
});
watch(
	() => route.name,
	async (newVal, oldVal) => {
		if (newVal !== oldVal) {
			setTimeout(() => setTab(newVal as RouteName), 0);
		}
	},
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(AuthorizedLayout, { title: "Měření" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(NTabs), {
            value: currentTab.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((currentTab).value = $event)),
            type: "line",
            "on-update:value": changeTab,
            size: "small"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab) => {
                return (_openBlock(), _createBlock(_unref(NTabPane), {
                  key: tab.id,
                  name: tab.id,
                  tab: tab.label
                }, null, 8, ["name", "tab"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_view)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})